export const formatMatchTime = (value) => {
  if (!value) return '--:--';

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '--:--';

  return parsed.toLocaleTimeString('tr-TR', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatMatchDateTime = (value) => {
  if (!value) return '--';

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '--';

  return parsed.toLocaleString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDisplayDate = (value) => {
  if (!value) return '--';

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    const fallback = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(fallback)) {
      const [year, month, day] = fallback.split('-');
      return `${day}.${month}.${year}`;
    }
    return fallback || '--';
  }

  return parsed.toLocaleDateString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};
